import axiosInstance from "./axiosInstance";

export interface AmenityApi {
  publicId: string;
  code: string;
  amenityName: string;
  amenityType: "Room" | "Property" | "Both";
  isActive: boolean;
  createdAt: string;
}

export interface AmenityListResponse {
  items: AmenityApi[];
  pageNo: number;
  pageSize: number;
  totalCount: number;
}

export interface CreateAmenityPayload {
  code: string;
  amenityName: string;
  amenityType: "Room" | "Property" | "Both";
  isActive: boolean;
}

export interface UpdateAmenityPayload {
  publicId: string;
  code: string;
  amenityName: string;
  amenityType: "Room" | "Property" | "Both";
  isActive: boolean;
}

export const getAuthHeader = () => {
  const token = localStorage.getItem("fhims_auth_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getAmenities = async (params: {
  searchText?: string | null;
  pageNo: number;
  pageSize: number; 
}): Promise<AmenityListResponse> => {
  const res = await axiosInstance.get("/amenities/list", {
    headers: getAuthHeader(),
    params,
  });

  return res.data;
};

export const createAmenity = async (payload: CreateAmenityPayload) => {
  const res = await axiosInstance.post("/amenities/create", payload, {
    headers: getAuthHeader(),
  });

  return res.data;
};

export const updateAmenity = async (payload: UpdateAmenityPayload) => {
  const res = await axiosInstance.put("/amenities/update", payload, {
    headers: getAuthHeader(),
  });

  return res.data;
};

export const deleteAmenity = async (publicId: string) => {
  const res = await axiosInstance.delete(`/amenities/${publicId}`, {
    headers: getAuthHeader(),
  });

  return res.data;
};